export enum PERMISSIONS {
    DIETICIAN_MANAGE = 'DIETICIAN_MANAGE',
    DIETICIAN_BALANCE = 'DIETICIAN_BALANCE',
    ADMIN_MANAGE = 'ADMIN_MANAGE',
    DIET_MANAGE = 'DIET_MANAGE',
    BEVERAGE_MANAGE = 'BEVERAGE_MANAGE',
    AILMENT_MANAGE = 'AILMENT_MANAGE',
    MEDICATION_MANAGE = 'MEDICATION_MANAGE',
    OFFICE_MANAGE = 'OFFICE_MANAGE',
    OFFICE_ASSIGN = 'OFFICE_ASSIGN',
    OFFICE_STATISTICS = 'OFFICE_STATISTICS',
    OFFICE_MESSAGE = 'OFFICE_MESSAGE',
    CLIENT_MANAGE = 'CLIENT_MANAGE',
    CLIENT_VALIDATE = 'CLIENT_VALIDATE',
    CLIENT_CONSULT = 'CLIENT_CONSULT',
}